import LatestAssets from 'components/modern/LatestAssets';
import { newsViewModel$ } from 'modules/news/news$';
import { connect } from 'rxbeach/react';
import { map } from 'rxjs/operators';

export default connect(
  LatestAssets,
  newsViewModel$.pipe(
    map(({ visibleNews }) => ({
      assets: visibleNews?.slice(0, 3) || [],
      route: 'nyheter',
    }))
  )
);
